class ReadMore extends HTMLElement {
  connectedCallback() {

    this.button = this.querySelector('.read-more__toggle');
    this.panel = this.querySelector('.read-more__inner');
    this.opened = false;

    const labels = {
      more: window.themeVariables.strings.readMore,
      less: window.themeVariables.strings.readLess,
    };

    // Checks if panel height is smaller than required
    // If so, removes "read more" functionality
    if (this.panel.scrollHeight <= this.panel.offsetHeight) {
      this.button.style.display = 'none';
      this.panel.classList.add('read-more__inner--fit');
    } else {
      this.button.style.display = null;
      this.panel.classList.remove('read-more__inner--fit');
    }

    this.toggleReadMore = () => {
      if (this.opened) {
        this.classList.remove('open');
        this.opened = false;
        this.panel.style.maxHeight = null;
        this.button.innerText = labels.more;
      } else {
        this.classList.add('open');
        this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
        this.opened = true;
        this.button.innerText = labels.less;
      }
    };

    this.button.addEventListener('click', this.toggleReadMore, false);
  }
}

customElements.define('read-more', ReadMore);

export default ReadMore;
